module.exports = __webpack_public_path__ + "nunito-sans-latin-400.8ace450709844437a579d4f4c7c37b42.woff";